import { render, staticRenderFns } from "./PageCategories.vue?vue&type=template&id=c3d11bfc&scoped=true&"
import script from "./PageCategories.vue?vue&type=script&lang=ts&"
export * from "./PageCategories.vue?vue&type=script&lang=ts&"
import style0 from "./PageCategories.vue?vue&type=style&index=0&id=c3d11bfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d11bfc",
  null
  
)

export default component.exports